var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"my-3 alert-box",attrs:{"value":true,"type":_vm.type,"dismissible":"","outline":"","transition":"fade-transition"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }